import React, { useState } from "react";
import {
  Alert,
  Layout,
  Button,
  Upload,
  message,
  Typography,
  Card,
} from "antd";
import {
  UploadOutlined,
  LogoutOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { QRCode } from "antd";
import Login from "./Login";
import { Modal, Input } from "antd";
import { useEffect } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { TimePicker } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons"; 
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import MobileCopyBox from "./MobileCopyBox";

const { Header, Content } = Layout;
const { Title, Text } = Typography;

const Membership = () => {
  const [user, setUser] = useState(null);
  const [hasPlan, setHasPlan] = useState(false); // demo purpose
  //const [dueDate, setDueDate] = useState("30 April 2025");
  const [phone, setPhone] = useState("");
  //const [loadingUserCheck, setLoadingUserCheck] = useState(false);
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(false);
  const [pendingUser, setPendingUser] = useState(null);

  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState("");
  const [joiningDate, setJoiningDate] = useState("");
  const [paymentUploaded, setPaymentUploaded] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [membershipRequests, setMembershipRequests] = useState([]);
  const [activeTab, setActiveTab] = useState("book");


  const beforeUpload = (file) => {
    setFile(file);  // just save file, don’t upload now
    setPaymentUploaded(true);
    return false;   // stops auto upload
  };



  const handleStartTimeChange = (time) => {
    setStartTime(time);
    const end = dayjs(time).add(1, "hour");
    setEndTime(end);
    setSelectedSlot(`${time.format("HH:mm A")} - ${end.format("HH:mm A")}`); // <-- Add this line
  };

  useEffect(() => {
    const fetchRequests = async () => {
      if (!user) return;
      try {
        const res = await axios.get(`https://uxzsrd33be23alhtpfmy5ziuc40vnldo.lambda-url.us-east-1.on.aws/membership-requests/${user.uid}`);
        const requests = res.data;
  
        const enrichedRequests = await Promise.all(
          requests.map(async (req) => {
            try {
              const planRes = await axios.get(`https://tkvxunknf5cpphpnkewzthvv4q0gzins.lambda-url.us-east-1.on.aws/membership-plans/${req.planId}`);
              return { ...req, planName: planRes.data.planName };
            } catch (error) {
              console.error("Error fetching plan:", error);
              return { ...req, planName: "Unknown Plan" };
            }
          })
        );

        const sortedRequests = enrichedRequests.sort((a, b) => {
          return new Date(b.submitDate) - new Date(a.submitDate); // descending order
        });


        console.log(sortedRequests);
        setMembershipRequests(sortedRequests);
      } catch (err) {
        console.error("Error fetching membership requests:", err);
      }
    };
  
    fetchRequests();
  }, [user]);  


    useEffect(() => {
      const fetchPlans = async () => {
        const res = await axios.get("https://tkvxunknf5cpphpnkewzthvv4q0gzins.lambda-url.us-east-1.on.aws/membership-plans");
        //console.log(res.data)
        setPlans(res.data);
      };
    
      fetchPlans();
    }, []);

    const handleSubmitMembership = async () => {
      if (!file) {
        message.error("Please upload payment screenshot.");
        return;
      }

      setSubmitting(true);
      try {
        // 1. Upload file to S3
        const uniqueId = uuidv4();
        const fileKey = `${user.displayName}_${selectedPlan.planName}_${joiningDate}_${uniqueId}.png`;
        const formData = new FormData();
        //const fileKey = `${user.displayName}_${selectedPlan.planName}_${joiningDate}.png`;
        formData.append("file", file);
        formData.append("key", fileKey);
    
        await axios.post("https://uxzsrd33be23alhtpfmy5ziuc40vnldo.lambda-url.us-east-1.on.aws/upload", formData);
        console.log("✅ Uploaded screenshot");
    
        // 2. Save Membership Info
        await axios.post("https://uxzsrd33be23alhtpfmy5ziuc40vnldo.lambda-url.us-east-1.on.aws/create-membership", {
          membershipId : uniqueId,
          userId: user.uid,
          planId: selectedPlan.planId,
          paymentURL: fileKey,
          joiningDate: joiningDate,   
          slot: selectedSlot,
        });
        console.log("✅ Payment saved");
    
        // 3. Save Membership Info
        
        console.log("✅ Membership saved");
    
        setTimeout(() => {
          Modal.success({
            title: "Membership Request Submitted!",
            content: "Your membership request has been sent. You'll be notified once it's approved.",
          });
        }, 100);
        // Optionally, reset form
        setSelectedPlan(null);
        setSelectedSlot("");
        setJoiningDate("");
        setPaymentUploaded(false);
        setFile(null);
      } catch (err) {
        console.error(err);
        message.error("Submission failed!");
      } finally {
        setSubmitting(false);
      }
    };    
    /*
  const handleUpload = (info) => {
    if (info.file.status === "done") {
      message.success(`${info.file.name} uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} upload failed.`);
    }
  };
  */
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);
      handleLogin(parsedUser); // 👈 Recheck and set plan status
    }
  }, []);

  const handleLogin = async (userData) => {
    //setLoadingUserCheck(true);
    const res = await axios.post("https://antwvob5jakwfih7vkhyzef7xm0iaaie.lambda-url.us-east-1.on.aws/check-user", {
      userId: userData.uid,
    });
  
    const data = await res.data;
    if (!data.exists) {
      setPendingUser(userData);
      setIsPhoneModalOpen(true);
    }
  
    if (data.exists) {
      setUser(userData);
      setHasPlan(data.activePlan); // 👈 update active plan
      localStorage.setItem("user", JSON.stringify(userData));
    }
  
    //setLoadingUserCheck(false);
  };

  const cleanedDisplayName = user?.displayName?.replace(/\s+/g, '') || 'user';
  const cleanedPlanName = selectedPlan?.planName?.replace(/\s+/g, '') || 'plan';
  const upiURL = selectedPlan
  ? `upi://pay?pa=${selectedPlan.upiVPA}&pn=${selectedPlan.upiName}&am=${selectedPlan.planCost}&tr=${cleanedDisplayName}${cleanedPlanName}&tn=${cleanedDisplayName}${cleanedPlanName}`
  : '';

  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-100 via-purple-200 to-orange-100">
      <Layout className="min-h-screen bg-transparent">
        {/* Navbar */}
        <Header className="flex justify-between items-center bg-black text-white px-6">
          <img src="/logo.png" alt="Logo" style={{ width: "40px", height: "40px" }} />
          {user ? (
            <Button icon={<LogoutOutlined />} onClick={() =>{localStorage.removeItem("user"); setUser(null);}}>
              Logout
            </Button>
          ) : (
            <Login onLogin={handleLogin} />
          )}
        </Header>

        {/* Main Content */}
        <Content className="p-6 bg-gradient-to-r from-blue-100 via-purple-200 to-orange-100 flex flex-col gap-6 items-center">

        <Modal
            title="You're new here! Enter your phone number"
            open={isPhoneModalOpen}
            onOk={async () => {
              await axios.post("https://6w6waxaixcmqqk7cm4lxj43he40rrdeo.lambda-url.us-east-1.on.aws/members", {
                userId: pendingUser.uid,
                userName: pendingUser.displayName,
                email: pendingUser.email,
                phone: phone,
              });
              setUser(pendingUser);
              setIsPhoneModalOpen(false);
            }}
            onCancel={() => setIsPhoneModalOpen(false)}
          >
            <Input
              placeholder="Phone Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </Modal>

          <div style={{ textAlign: "center", marginTop: "16px" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "12px" }}>
              <Title level={2} style={{ margin: 0 }}>Pavan's Badminton Academy</Title>
            </div>
            <Title level={3}>
              Membership Portal
            </Title>
          </div>

          <Text>If any problem or query regarding payment or slots contact : +91 8100376761 (Mr. Vaithianathan Ananthakrishnan)</Text>
          <Text>If you face any errors in the website, screenshot it and mail to : helpdesk.pavans@gmail.com</Text>
          
          {!user && <Login onLogin={handleLogin} />}
          
          {user && (<div className="flex flex-row mb-4" >
            <div>
            <Button
              type={activeTab === "book" ? "primary" : "default"}
              size="large"
              className="w-60"
              onClick={() => setActiveTab("book")}
            >
              Book Membership
            </Button>
            </div>
            <div style={{marginLeft: "10px" }}>
            <Button
              type={activeTab === "submissions" ? "primary" : "default"}
              size="large"
              className="w-60"
              style={{ marginRight: "10px" }}
              onClick={() => setActiveTab("submissions")}
            >
              Previous Submissions
            </Button>
            </div>
          </div> )
          }

          {user ? (
            <>
              <Text strong>Hello, {user.displayName}</Text>

              {hasPlan ? (
                <>
                  <Card
                    bordered
                    className="w-full max-w-xl shadow-md hover:shadow-2xl cursor-pointer rounded-2xl"
                    onClick={() => message.info("Slot booking coming soon!")}
                  >
                    <div className="flex items-center justify-center gap-3">
                      <CalendarOutlined style={{ fontSize: "20px" }} />
                      <Text strong>Book a Slot</Text>
                    </div>
                  </Card>
                </>
              ) : (
                <>
                  <> 
                  {
                    activeTab === "submissions" && (
                      <Card
                      title="Past Membership Requests"
                      bordered
                      className="w-full max-w-xl shadow-md rounded-2xl mt-4"
                    >
                      {Array.isArray(membershipRequests) && membershipRequests.length > 0 ? (
                        membershipRequests.map((req, index) => (
                          <>
                          <Card key={index} className="mb-2 bg-white">
                            <Text><strong>Plan:</strong> {req.planName}</Text><br />
                            <Text><strong>Joining Date:</strong> {req.joiningDate}</Text><br />
                            <Text><strong>Ending Date:</strong> {req.dueDate}</Text><br />
                            <Text><strong>Slot:</strong> {req.slot}</Text><br />
                            <Text style={{
                              color: req.paymentStatus === "pending" ? "#d48806" :    // yellow-ish
                                    req.paymentStatus === "accepted" ? "#389e0d" :    // green
                                    req.paymentStatus === "rejected" ? "#cf1322" :    // red
                                    "black",
                              fontWeight: "bold"
                            }}>
                              Status: {req.paymentStatus}
                            </Text>
                            <br />
                            <Text><strong>Submitted On:</strong> {req.submitDate}</Text><br />
                            <Text><strong>Screenshot Uploaded:</strong> <Button
                                onClick={() => window.open(req.paymentURL, "_blank")}
                                className="mt-2"
                              >
                                View Payment Screenshot
                              </Button><br />
                            </Text><br />
  
                          </Card>
                          <br></br>
                          
                          </>
                        ))
                      ) : (
                        <Text>No previous requests found.</Text>
                      )}
                    </Card>

                    )
                  }
                  </>


                  {activeTab === "book" && (
                    <Card
                      title="Join Membership"
                      bordered
                      className="w-full max-w-xl shadow-xl rounded-2xl flex flex-col gap-4"
                    >
                      <Alert
                        message="Note"
                        description="Please check with the coach via whatsapp (which also the UPI Number given below) about the price before making the payment."
                        type="info"
                        showIcon
                        closable
                      />
                      <Text strong>Select a Plan:</Text>
                      <div className="flex flex-col gap-2">
                        {plans.map((plan) => (
                          <Card
                            key={plan.planId}
                            className={`border-2 flex justify-between items-center ${
                              selectedPlan?.planId === plan.planId
                                ? "border-blue-500 bg-blue-100"
                                : "border-gray-300 bg-white"
                            } cursor-pointer`}
                            onClick={() => setSelectedPlan(plan)}
                          >
                            <Text>{plan.planName} - ₹{plan.planCost}</Text>
                            {selectedPlan?.planId === plan.planId && (
                              <CheckCircleOutlined style={{ color: "#3b82f6", fontSize: "20px", marginLeft: "10px" }} />
                            )}
                          </Card>
                        ))}
                      </div>

                      <div>
                        <Text strong>Select Slot:</Text>
                        <div className="w-full max-w-xl">
                          <Text strong>Select Slot (1 hour):</Text>
                          <TimePicker
                            format="HH:mm A"
                            minuteStep={60}
                            onChange={handleStartTimeChange}
                            style={{ width: "100%", marginTop: "8px" }}
                          />

                          {startTime && endTime && (
                            <Text type="success" className="block mt-2">
                              Selected Slot: {startTime.format("HH:mm A")} to {endTime.format("HH:mm A")}
                            </Text>
                          )}
                        </div>
                      </div>

                      <div>
                        <Text strong>Select Joining Date:</Text>
                        <div className="flex gap-2 mt-2 mb-2">
                          <Button onClick={() => setJoiningDate(dayjs().format("YYYY-MM-DD"))}>Today</Button>
                          <Button onClick={() => setJoiningDate(dayjs().add(1, "day").format("YYYY-MM-DD"))}>Tomorrow</Button>
                        </div>
                        <Input
                          type="date"
                          value={joiningDate}
                          onChange={(e) => setJoiningDate(e.target.value)}
                          className="w-full"
                        />
                      </div>

                      <div>
                        <br></br>
                        <div className="flex flex-col items-center justify-center my-2">
                        <Text strong>Pay ₹{selectedPlan?.planCost || 0} to Join</Text>
                        
                        <Text> Scan QR Code with Any UPI App to Pay</Text>
                          <QRCode
                            value={
                              selectedPlan
                                ? upiURL
                                : ""
                            } 
                            icon="/logo.png"                           
                            size={150}
                          />  
                          <br></br>

                          <Text>Or Copy this UPI Mobile Number to Pay via Preferred Payment method : </Text>
                          <MobileCopyBox/>
                          <br></br>
                          {selectedPlan && (
                          <a
                            href={upiURL}
                            style={{ display: "inline-block" }}
                          >
                            <Button className="flex justify-center my-2" type="primary">Open UPI App</Button>
                          </a>
                        )}
                        </div>


                        <div className="flex justify-center gap-6 mt-2">
                          <img src="/gpay.png" alt="Google Pay" className="w-6 h-6" />
                          <img src="/phonepe.png" alt="PhonePe" className="w-6 h-6" />
                          <img src="/paytm.png" alt="Paytm" className="w-6 h-6" />
                          <img src="/bhim.png" alt="BHIM" className="w-6 h-6" />
                        </div>

                        <br></br>
                        <Upload
                          beforeUpload={beforeUpload}
                          maxCount={1}
                          showUploadList={{ showRemoveIcon: true }}
                        >

                          <br></br>
                          <Button icon={<UploadOutlined />}>Upload Payment Screenshot</Button>
                        </Upload>
                      </div>
                        <br></br>
                      <Button
                        type="primary"
                        className="mt-4"
                        disabled={!selectedPlan || !selectedSlot || !joiningDate || !paymentUploaded}
                        onClick={handleSubmitMembership}
                        loading={submitting}
                      >
                        Submit Request
                      </Button>
                    </Card>
                  )}
                </>
              )}
            </>
          ) : (
            <>
            <Text className="mt-4 text-lg text-gray-700 text-center">
              Please login to access your membership details.
            </Text>
            <Button onClick={() => navigate(-1)} className="mb-4 px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">
                  ← Back
            </Button>
            </>
          )}
        </Content>

      </Layout>
    </div>
  );
};

export default Membership;
